import React from 'react';
import i18n from '../../../translate/i18n';

import Textarea from '../../Form/Textarea';
import Radio from '../../Form/Radio';

import ImgMenuPesquisa from '../../../assets/images/image-pesquisa.svg';

import './styles.css'
import { FaStar } from 'react-icons/fa'
import UploadFiles from 'components/Form/UploadFiles';


interface TypeProps {
  data: any,
  handleSelectChange: Function,
  handleInputChange: Function,
  setData: Function
}

export default function Despesas({ data, handleSelectChange, handleInputChange, setData }: TypeProps) {

  return (
    <div className='container-box'>
      <h5>{i18n.t<string>('edit.expenses')}</h5>
      <hr />
      <form >
        {
          data.id &&
          <UploadFiles
            name="images"
            label="Inserir imagens e/ou documentos dos tipos: PNG, JPEG, JPG e PDF"
            osId={data?.id}
            etapa={'despesas'}
          />
        }
      </form>
    </div>
  )
}
